import { render, staticRenderFns } from "./NewslettersList.vue?vue&type=template&id=5662b24e&scoped=true"
import script from "./NewslettersList.vue?vue&type=script&lang=js"
export * from "./NewslettersList.vue?vue&type=script&lang=js"
import style0 from "./NewslettersList.vue?vue&type=style&index=0&id=5662b24e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5662b24e",
  null
  
)

export default component.exports